import { OrganizationTeamResponseDto, PrismaWorkspaceDto } from 'app/API';

export const findTeamWorkspace = (
  teams: OrganizationTeamResponseDto[] | undefined,
  teamId: string,
  workspaceSlug: string,
): PrismaWorkspaceDto | undefined =>
  teams?.find((team) => team.id === teamId)?.Workspaces?.find((workspace) => workspace.slug === workspaceSlug);
